import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function GameCard({ name, banner, slug }) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageBlur, setImageBlur] = useState(true);

    const handleImageLoad = () => {
        setImageLoaded(true);
        setTimeout(() => setImageBlur(false), 800);
    };

    return (
        <div className="group relative bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-black rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:shadow-purple-500/20 dark:hover:shadow-cyan-500/20 transition-all duration-300 ease-out transform hover:-translate-y-1 sm:hover:-translate-y-2 hover:scale-102 sm:hover:scale-105 touch-manipulation">
            <Link to={`/game/${slug?.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-') || ''}`} className="block">
                <div className="relative overflow-hidden w-full">
                    {!imageLoaded && (
                        <div className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 w-full h-24 xs:h-28 sm:h-32 md:h-36 lg:h-28 xl:h-32 2xl:h-40 animate-pulse">
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer"></div>
                        </div>
                    )}
                    <img
                        src={banner}
                        alt={name}
                        className={`w-full h-24 xs:h-28 sm:h-32 md:h-36 lg:h-28 xl:h-32 2xl:h-40 object-cover transition-all duration-500 group-hover:scale-105 sm:group-hover:scale-110 ${!imageLoaded ? 'blur hidden' : 'blur-none'}`}
                        style={imageBlur ? { filter: 'blur(20px)' } : {}}
                        onLoad={handleImageLoad}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute top-1 right-1 sm:top-2 sm:right-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 group-hover:translate-x-0">
                        <span className="hidden xs:inline">Play Now</span>
                        <span className="xs:hidden">Play</span>
                    </div>
                </div>
                <div className="p-2 sm:p-3 relative">
                    <p className="text-xs sm:text-sm font-bold text-center truncate dark:text-white text-gray-800 group-hover:text-purple-600 dark:group-hover:text-cyan-400 transition-colors duration-300 leading-tight">
                        {name}
                    </p>
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-purple-500 to-pink-500 group-hover:w-full transition-all duration-300"></div>
                </div>
            </Link>
        </div>
    );
}

export default GameCard;
